export default {
  title: 'HubRise',
  setup: {
    description: 'Teile Daten mit anderen Anwendungen.',
  },
  form: {
    is_menus_sync_enabled: 'Menü synchronisieren',
    is_inventory_sync_enabled: 'Bestand synchronisieren',
    is_opening_hours_sync_enabled: 'Öffnungszeiten synchronisieren',
    is_order_acceptance_mode_sync_enabled: 'Beschäftigt-/Pausiert-Status synchronisieren',
    variant_ref: 'Menüvariante',
    variant_ref_default: 'Standard',
  },
  tabs: {
    settings: 'Einstellungen',
    service_types: 'Servicearten',
    payments: 'Zahlungen',
    charges: 'Gebühren',
    deals: 'Angebote',
    discounts: 'Rabatte',
    customers: 'Kunden',
  },
  customers: {
    description:
      'Lösche die Daten eines einzelnen Kunden auf HubRise-Seite, zum Beispiel nach einer Löschanfrage. Dies kann nicht rückgängig gemacht werden.',
    customer: 'Kunde',
    placeholder: 'Nach Name, E-Mail oder Telefon suchen…',
  },
  mapping: {
    description:
      'Ordne jede {{provider}}-Entität dem passenden HubRise-Wert und -Namen zu. Lasse eine Zeile leer, um die {{provider}}-Standardwerte zu verwenden.',
    entity: '{{provider}}',
    value: 'HubRise-Wert',
    name: 'HubRise-Name',
  },
  connecting: {
    title: 'HubRise-Verbindung wird abgeschlossen…',
    description: 'Das dauert einige Sekunden. Bitte lasse diese Seite geöffnet.',
    error_title: 'Die HubRise-Verbindung dauert länger als erwartet',
    error_description:
      'HubRise wurde autorisiert, die Verbindung ist aber noch nicht bestätigt. Prüfe es in einem Moment erneut — falls es weiterhin fehlschlägt, starte die Verbindung neu.',
  },
  buttons: {
    connect: 'Mit HubRise verbinden',
    check_again: 'Erneut prüfen',
    disconnect: 'Trennen',
    go_to_hubrise: 'Zu HubRise',
    pull_menus: 'Menü abrufen',
    pull_inventory: 'Bestand abrufen',
    save: 'Speichern',
    delete_customer: 'Kunde löschen',
  },
  toasts: {
    connected: 'HubRise wurde verbunden',
    connect_cancelled: 'HubRise-Verbindung wurde abgebrochen',
    connect_error: 'Verbindung zu HubRise konnte nicht gestartet werden',
    connect_timeout: 'Die HubRise-Verbindung konnte noch nicht bestätigt werden',
    local_changes_replaced:
      'Die HubRise-Einstellungen wurden an anderer Stelle geändert — deine nicht gespeicherten Änderungen wurden ersetzt',
    disconnect_success: 'HubRise wurde getrennt',
    disconnect_error: 'HubRise konnte nicht getrennt werden',
    pull_menus_success: 'Menüsynchronisierung wurde gestartet',
    pull_menus_error: 'Menü konnte nicht abgerufen werden',
    pull_inventory_success: 'Bestandssynchronisierung wurde gestartet',
    pull_inventory_error: 'Bestand konnte nicht abgerufen werden',
    save_success: 'HubRise-Einstellungen wurden gespeichert',
    save_error: 'HubRise-Einstellungen konnten nicht gespeichert werden',
    load_customers_error: 'Kunden konnten nicht geladen werden',
    delete_customer_success: 'Die Löschung der Kundendaten wurde angefordert',
    delete_customer_error: 'Kundendaten konnten nicht gelöscht werden',
  },
  delete_customer_confirm: {
    title: 'Diesen Kunden aus HubRise löschen?',
    description: 'Die Daten des Kunden werden auf HubRise-Seite gelöscht. Dies kann nicht rückgängig gemacht werden.',
    ok: 'Löschen',
    cancel: 'Abbrechen',
  },
  disconnect_confirm: {
    title: 'HubRise trennen?',
    description: 'Dadurch werden Menüs, Bestand und Bestellungen nicht mehr mit HubRise synchronisiert.',
    ok: 'Trennen',
    cancel: 'Abbrechen',
  },
  connected: {
    title: 'Mit HubRise verbunden',
    description: 'Dein HubRise-Konto ist erfolgreich verknüpft.',
    account: 'Konto',
    location: 'Standort',
    catalog: 'Katalog',
    customer_list: 'Kundenliste',
  },
};
